module.exports = __webpack_public_path__ + "img/icon-page-right.efd116dc.svg";